export default __webpack_public_path__ + "fonts/poppins-latin-500-normal.8609f9c59114a158e3ad.woff";